import { defineMessages } from "react-intl";

const messages = defineMessages({
  activityDateTimeDescription: {
    id: "email.creation.baseActivitiesCreateModal.activityDateTimeDescription",
    defaultMessage: "Date and time will be a reflection of when each email is sent",
    description: "Activity date and time description in activity creation modal",
  },
  activityName: {
    id: "email.creation.baseActivitiesCreateModal.activityName",
    defaultMessage: "Title",
    description: "Activity name label in activity creation modal",
  },
  activityNameDisabledBecauseItUsesDynamicVariable: {
    id: "email.creation.baseActivitiesCreateModal.activityNameDisabledBecauseItUsesDynamicVariable",
    defaultMessage: "This activity name can’t be changed because it uses a dynamic variable.",
    description: "Visibility field label in Create create edit activity modal",
  },
  activityType: {
    id: "email.creation.baseActivitiesCreateModal.activityType",
    defaultMessage: "Type",
    description: "Activity type label in activity creation modal",
  },
  assignee: {
    id: "email.creation.baseActivitiesCreateModal.assignee",
    defaultMessage: "Assignee",
    description: "Assignee label in activity creation modal",
  },
  closeConfirmationDescription: {
    id: "email.creation.baseActivitiesCreateModal.closeConfirmation.description",
    defaultMessage: "Emails will not be sent and activities will not be created.",
    description: "Close confirmation description",
  },
  closeConfirmationNo: {
    id: "email.creation.baseActivitiesCreateModal.closeConfirmationNo",
    defaultMessage: "No, Stay",
    description: "Close confirmation no",
  },
  closeConfirmationYes: {
    id: "email.creation.baseActivitiesCreateModal.closeConfirmationYes",
    defaultMessage: "Yes, exit",
    description: "Close confirmation yes",
  },
  doesNotRepeat: {
    id: "email.creation.baseActivitiesCreateModal.doesNotRepeat",
    defaultMessage: "Does not repeat",
    description: "Does not repeat label in activity creation modal",
  },
  emptyTextForWithSkippedUsers: {
    id: "email.creation.baseActivitiesCreateModal.field.note.emptyTextForWithSkippedUsers",
    defaultMessage:
      "Only users that have view or edit access to either the association or the activity will receive a notification",
    description:
      "Message for the Activity Note mention dropdown when some disabled users are skipped",
  },
  goBack: {
    id: "email.creation.baseActivitiesCreateModal.goBack",
    defaultMessage: "Go back",
    description: "Go back button in activity creation modal",
  },
  note: {
    id: "email.creation.baseActivitiesCreateModal.note",
    defaultMessage:
      "Values will be filled for all activities generated. You can edit individual activities after creation. Activities are not generated until the email is actually sent.",
    description: "Note in activity creation modal",
  },
  notificationsDisabled: {
    id: "email.baseActivitiesCreateModal.notificationsDisabled",
    defaultMessage: "Notifications disabled",
    description: "Notifications are disabled for this email",
  },
  scheduleDateTimeFormat: {
    id: "email.creation.baseActivitiesCreateModal.scheduleDateTimeFormat",
    defaultMessage: "EEEE, MMM d 'at' h:mm a",
    description:
      "Date-fns format string for displaying scheduled email date and time (e.g. Wednesday, Feb 22 at 6:45 AM)",
  },
  scheduleEmailChechbox: {
    id: "email.creation.baseActivitiesCreateModal.scheduleEmailChechbox",
    defaultMessage: "Schedule date and time email is sent",
    description: "Label for checkbox to schedule email send time in activity creation modal",
  },
  schedulePlaceholder: {
    id: "email.creation.baseActivitiesCreateModal.schedulePlaceholder",
    defaultMessage: "Select date and time",
    description: "Placeholder for schedule date and time picker in activity creation modal",
  },
  teamsRequired: {
    id: "email.creation.baseActivitiesCreateModal.field.visibility.teamsRequired",
    defaultMessage: "Please select team",
    description: "Visibility field teams required message in email activity modal",
  },
  title: {
    id: "email.creation.baseActivitiesCreateModal.title",
    defaultMessage: "Create {count} {count, plural, one {Activity} other {Activities}}",
    description: "Title of activity creation modal",
  },
  uniqueFieldRequiredTooltip: {
    id: "email.creation.baseActivitiesCreateModal.uniqueField.required.tooltip.title",
    defaultMessage:
      "There is a required field where the value must be unique, so only one recipient can be emailed at a time.",
    description: "Tooltip for send button when a custom field is required and unique",
  },
  visibility: {
    id: "email.creation.baseActivitiesCreateModal.field.visibility",
    defaultMessage: "This activity name can’t be changed because it uses a dynamic variable.",
    description:
      "Activity name disabled because it uses a dynamic variable label in Create create edit activity modal",
  },
});

export default messages;
